export const enum ReportParamMetaTypes {
	Range = 11,
}
